var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrivalIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1184_4350",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "#DEA829"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1184_4350)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.7191 5.24944C16.4876 5.24944 14.6562 5.2363 13.4247 5.25765C12.9118 5.26668 12.6127 5.62948 12.5975 6.16794C12.5895 6.44127 12.6063 6.71543 12.5903 6.98794C12.5584 7.52558 12.2107 7.87279 11.7289 7.8695C11.2639 7.86622 10.8914 7.52722 10.8906 7.01421C10.889 6.45851 10.8866 5.88147 11.0214 5.3504C11.2974 4.25706 12.2912 3.50847 13.3888 3.50519C16.4979 3.49698 19.6079 3.49862 22.7171 3.5093C23.8002 3.5134 24.4974 4.25706 24.4982 5.37995C24.5006 10.5487 24.4998 15.7182 24.4982 20.8869C24.4982 21.8112 24.0802 22.4186 23.2379 22.7091C21.6155 23.2698 19.9924 23.8287 18.3668 24.3787C17.0682 24.8187 15.9994 24.0233 15.9827 22.6164C15.9803 22.3874 15.9827 22.1584 15.9827 21.8883C15.1755 21.8883 14.4081 21.8883 13.6408 21.8883C11.9466 21.8867 10.8826 20.7901 10.8778 19.0442C10.877 18.5656 10.8706 18.0871 10.8802 17.6086C10.8922 17.0176 11.2384 16.6334 11.7401 16.6359C12.2402 16.6383 12.5824 17.0233 12.5927 17.6168C12.6023 18.1634 12.5863 18.7109 12.5999 19.2576C12.6119 19.7517 12.9062 20.1088 13.3808 20.126C14.2271 20.1564 15.0758 20.1342 15.9827 20.1342V19.6294C15.9827 15.5409 15.9914 11.4516 15.9763 7.36306C15.9731 6.4265 18.9339 6.00375 19.3726 5.24944H17.7191Z",
    fill: "url(#paint0_linear_1184_4350)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.74582 11.3811C7.74582 10.5373 7.75141 9.75836 7.74343 8.98022C7.73864 8.5222 7.84632 8.13067 8.29619 7.94517C8.7301 7.76623 9.05713 7.97307 9.35863 8.28663C10.3868 9.35452 11.4237 10.4134 12.455 11.4772C12.999 12.0386 13.003 12.472 12.4686 13.0236C11.4277 14.0972 10.382 15.1659 9.34427 16.2429C9.04117 16.5572 8.71415 16.7501 8.27944 16.5613C7.84792 16.3734 7.74263 15.9974 7.74502 15.5566C7.74981 14.7662 7.74662 13.9749 7.74662 13.1278C7.5177 13.1278 7.32228 13.1278 7.12766 13.1278C6.22474 13.1278 5.32182 13.1336 4.4189 13.1246C3.86854 13.1196 3.50402 12.7683 3.50003 12.2652C3.49604 11.7505 3.87731 11.3861 4.44203 11.3828C5.39839 11.3778 6.35396 11.3811 7.31032 11.3811C7.44033 11.3811 7.56955 11.3811 7.74582 11.3811Z",
    fill: "url(#paint1_linear_1184_4350)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1184_4350",
    x1: 17.6873,
    y1: 3.5,
    x2: 17.6873,
    y2: 24.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEA829"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE8888"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1184_4350",
    x1: 8.18312,
    y1: 7.87891,
    x2: 8.18312,
    y2: 16.6359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEA829"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE8888"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrivalIcon);
export default __webpack_public_path__ + "static/media/arrival_icon.7cb9db720d0286d2b1e0d211d3730a27.svg";
export { ForwardRef as ReactComponent };